/**
 * Kamus dwibahasa untuk halaman publik (Pengumuman Tender + Privacy Policy).
 *
 * Sengaja BERDIRI SENDIRI, tidak memakai i18next global (`src/i18n.js`) karena:
 * 1. i18next global belum punya locale Indonesia sama sekali (hanya ar/ch/en/
 *    fr/gr/it/ru/sp);
 * 2. i18next global menyimpan pilihan bahasa pada kunci localStorage
 *    `I18N_LANGUAGE` yang dipakai bersama aplikasi ber-login — mengubah bahasa
 *    dari halaman publik akan ikut mengubah menu aplikasi internal.
 *
 * Modul ini memakai kunci sendiri (`PUBLIC_LANDING_LANG`) sehingga tidak
 * bersinggungan dengan aplikasi internal.
 */

export const LANGUAGES = [
  { code: 'id', label: 'Indonesia', short: 'ID' },
  { code: 'en', label: 'English', short: 'EN' },
];

export const DEFAULT_LANGUAGE = 'id';

const translations = {
  id: {
    // ── Layout ──
    'layout.brand': 'HYROC - Platform Pengadaan Energi',
    'layout.login': 'Login',
    'layout.language': 'Bahasa',
    'layout.privacy': 'Kebijakan Privasi',
    'layout.backHome': 'Kembali ke Beranda',
    'table.sortAsc': 'urutkan naik',
    'table.sortDesc': 'urutkan turun',
    'layout.copyright': '© {year} PT Pertamina (Persero)',

    // ── Landing HYROC (halaman `/`) ──
    'landing.tagline': 'Platform Pengadaan Energi',
    'landing.announcement': 'Pengumuman',
    'landing.login': 'Login',
    'landing.registration': 'Registrasi',
    'landing.documentTitle': 'HYROC | Platform Pengadaan Energi',
    'landing.logoAlt': 'Pertamina Patra Niaga',

    // ── Halaman list ──
    'list.title': 'Pengumuman Tender',
    'list.desc':
      'Pengumuman resmi untuk pengadaan aktif dan selesai dari minyak mentah, kondensat, dan produk olahan/hidrokarbon di lingkungan Pertamina.',
    'list.chipActive': '{count} Tender Aktif',
    'list.chipFinished': '{count} Selesai',
    'list.documentTitle': 'Pengumuman Tender | HYROC',

    'filter.search': 'Pencarian',
    'filter.searchPlaceholder': 'Nama pekerjaan atau nomor pengadaan',
    'filter.dateFrom': 'Tanggal Pengumuman Dari',
    'filter.dateTo': 'Sampai',
    'filter.status': 'Status',
    'filter.allStatus': 'Semua Status',
    'filter.submit': 'Cari',
    'filter.reset': 'Reset',

    'table.announcementDate': 'Tanggal Pengumuman (WIB)',
    'table.time': 'Waktu (WIB)',
    'table.title': 'Tender Requirement',
    'table.category': 'Jenis Pengadaan',
    'table.deadline': 'Batas Akhir (WIB)',
    'table.status': 'Status',
    'table.bid': 'BID',

    'tab.all': 'Semua Pengadaan',
    'tab.product': 'Produk',
    'tab.crude': 'Minyak Mentah & Kondensat',

    'state.empty': 'Belum ada pengumuman tender pada rentang ini.',
    'state.resetFilter': 'Reset Filter',
    'state.error': 'Gagal memuat data. Coba muat ulang halaman.',
    'state.retry': 'Coba Lagi',

    'pagination.showing': 'Menampilkan {from}-{to} dari {total}',
    'pagination.prev': 'Sebelumnya',
    'pagination.next': 'Berikutnya',

    // ── Status publik ──
    'status.Announced': 'Diumumkan',
    'status.BiddingOpen': 'Penawaran Dibuka',
    'status.BiddingClosed': 'Penawaran Ditutup',

    // ── Halaman detail ──
    'detail.back': 'Kembali ke Pengumuman',
    'detail.viewCount': 'BID {count}',
    'detail.cardInfo': 'Informasi Pengadaan',
    'detail.cardSummary': 'Ringkasan Pengadaan',
    'detail.cardAttachments': 'Lampiran',
    'detail.noAttachment': 'Tidak ada lampiran.',
    'detail.download': 'Unduh',
    'detail.notFoundTitle': 'Pengumuman tidak ditemukan',
    'detail.notFoundDesc':
      'Pengumuman yang Anda cari tidak tersedia atau sudah tidak ditampilkan.',
    'detail.errorTitle': 'Gagal memuat data',
    'detail.errorDesc': 'Silakan coba muat ulang halaman.',

    'field.procurementNumber': 'Nomor Pengadaan',
    'field.titleProcurement': 'Nama Pengadaan',
    'field.announcementDate': 'Tanggal Pengumuman',
    'field.procurementType': 'Cara Pengadaan',
    'field.procurementTypeHeader': 'Jenis Pengadaan',
    'field.contractType': 'Tipe Kontrak',
    'field.status': 'Status',
    'field.deadline': 'Closing Date',
    'field.awardedTo': 'Rekanan Pemenang',

    // ── Kebijakan privasi ──
    'privacy.title': 'Kebijakan Privasi',
    'privacy.documentTitle': 'Kebijakan Privasi | HYROC',
    'privacy.lastUpdated': 'Terakhir diperbarui: {date}',
    'privacy.draftNotice':
      'Naskah ini masih rancangan dan belum ditinjau Fungsi Legal & Compliance. Rincian kontak dan tenggat penyimpanan data di bawah masih berupa contoh dan wajib diperiksa sebelum halaman ini ditayangkan ke publik.',
    'privacy.back': 'Kembali ke Pengumuman',

    // ── Panel login yang menyatu di halaman pengumuman ──
    'login.title': 'Selamat datang kembali',
    'login.subtitle': 'Masuk ke akun Anda untuk melanjutkan',
    'login.username': 'Nama Pengguna',
    'login.usernamePlaceholder': 'Masukkan nama pengguna',
    'login.password': 'Kata Sandi',
    'login.passwordPlaceholder': 'Masukkan kata sandi',
    'login.remember': 'Ingat saya',
    'login.signIn': 'Masuk',
    'login.signingIn': 'Sedang masuk...',
    'login.or': 'atau lanjutkan dengan',
    'login.idaman': 'Masuk dengan idAMan',
    'login.processing': 'Memproses...',
    'login.footer': '© {year} PT Pertamina (Persero). Hak cipta dilindungi.',
    'login.showPassword': 'Tampilkan kata sandi',
    'login.hidePassword': 'Sembunyikan kata sandi',
    'login.requiredUsername': 'Nama pengguna wajib diisi',
    'login.requiredPassword': 'Kata sandi wajib diisi',
  },

  en: {
    // ── Layout ──
    'layout.brand': 'HYROC - Energy Procurement Platform',
    'layout.login': 'Login',
    'layout.language': 'Language',
    'layout.privacy': 'Privacy Policy',
    'layout.backHome': 'Back to Home',
    'table.sortAsc': 'sort ascending',
    'table.sortDesc': 'sort descending',
    'layout.copyright': '© {year} PT Pertamina (Persero)',

    // ── HYROC landing (`/` page) ──
    'landing.tagline': 'Energy Procurement Platform',
    'landing.announcement': 'Announcement',
    'landing.login': 'Login',
    'landing.registration': 'Registration',
    'landing.documentTitle': 'HYROC | Energy Procurement Platform',
    'landing.logoAlt': 'Pertamina Patra Niaga',

    // ── List page ──
    'list.title': 'Tender Announcements',
    'list.desc':
      'Official announcements for active and completed procurements of crude oil, condensate, and refined/hydrocarbon products within Pertamina.',
    'list.chipActive': '{count} Active Tenders',
    'list.chipFinished': '{count} Completed',
    'list.documentTitle': 'Tender Announcements | HYROC',

    'filter.search': 'Search',
    'filter.searchPlaceholder': 'Work name or procurement number',
    'filter.dateFrom': 'Announcement Date From',
    'filter.dateTo': 'To',
    'filter.status': 'Status',
    'filter.allStatus': 'All Statuses',
    'filter.submit': 'Search',
    'filter.reset': 'Reset',

    'table.announcementDate': 'Announcement Date (Jakarta Local Time)',
    'table.time': 'Time (Jakarta Local Time)',
    'table.title': 'Tender Requirement',
    'table.category': 'Procurement Type',
    'table.deadline': 'Submission Deadline (Jakarta Local Time)',
    'table.status': 'Status',
    'table.bid': 'BID',

    'tab.all': 'All Procurement',
    'tab.product': 'Product',
    'tab.crude': 'Crude & Condensate',

    'state.empty': 'No tender announcements found for this range.',
    'state.resetFilter': 'Reset Filter',
    'state.error': 'Failed to load data. Please reload the page.',
    'state.retry': 'Try Again',

    'pagination.showing': 'Showing {from}-{to} of {total}',
    'pagination.prev': 'Previous',
    'pagination.next': 'Next',

    // ── Public status ──
    'status.Announced': 'Announced',
    'status.BiddingOpen': 'Bidding Open',
    'status.BiddingClosed': 'Bidding Closed',

    // ── Detail page ──
    'detail.back': 'Back to Announcements',
    'detail.viewCount': 'BID {count}',
    'detail.cardInfo': 'Procurement Information',
    'detail.cardSummary': 'Procurement Summary',
    'detail.cardAttachments': 'Attachments',
    'detail.noAttachment': 'No attachments.',
    'detail.download': 'Download',
    'detail.notFoundTitle': 'Announcement not found',
    'detail.notFoundDesc':
      'The announcement you are looking for is unavailable or no longer displayed.',
    'detail.errorTitle': 'Failed to load data',
    'detail.errorDesc': 'Please try reloading the page.',

    'field.procurementNumber': 'Procurement Number',
    'field.titleProcurement': 'Procurement Name',
    'field.announcementDate': 'Announcement Date',
    'field.procurementType': 'Procurement Method',
    'field.procurementTypeHeader': 'Procurement Category',
    'field.contractType': 'Contract Type',
    'field.status': 'Status',
    'field.deadline': 'Closing Date',
    'field.awardedTo': 'Awarded Supplier',

    // ── Privacy policy ──
    'privacy.title': 'Privacy Policy',
    'privacy.documentTitle': 'Privacy Policy | HYROC',
    'privacy.lastUpdated': 'Last updated: {date}',
    'privacy.draftNotice':
      'This text is a draft and has not been reviewed by the Legal & Compliance function. The contact details and data retention periods below are placeholders and must be verified before this page is published.',
    'privacy.back': 'Back to Announcements',

    // ── Login panel embedded in the announcement page ──
    'login.title': 'Welcome back',
    'login.subtitle': 'Sign in to your account to continue',
    'login.username': 'User Name',
    'login.usernamePlaceholder': 'Enter your username',
    'login.password': 'Password',
    'login.passwordPlaceholder': 'Enter your password',
    'login.remember': 'Remember me',
    'login.signIn': 'Sign In',
    'login.signingIn': 'Logging in...',
    'login.or': 'or continue with',
    'login.idaman': 'Login with idAMan',
    'login.processing': 'Processing...',
    'login.footer': '© {year} PT Pertamina (Persero). All rights reserved.',
    'login.showPassword': 'Show password',
    'login.hidePassword': 'Hide password',
    'login.requiredUsername': 'Please enter your user name',
    'login.requiredPassword': 'Please enter your password',
  },
};

/**
 * Terjemahkan satu kunci. `params` mengganti token `{nama}` di dalam teks.
 * Kunci yang belum diterjemahkan jatuh ke bahasa Indonesia, lalu ke kunci itu
 * sendiri — supaya kekurangan terjemahan terlihat, bukan menghasilkan teks kosong.
 */
export const translate = (lang, key, params = {}) => {
  const dictionary = translations[lang] || translations[DEFAULT_LANGUAGE];
  const fallback = translations[DEFAULT_LANGUAGE];
  const raw = dictionary[key] ?? fallback[key] ?? key;

  return Object.keys(params).reduce(
    (text, name) => text.split(`{${name}}`).join(String(params[name])),
    raw
  );
};

export default translations;
